import RequestUtil from "../utils/RequestUtil";
import Requests from "./Requests";

const basePath = "/explore.personallists.v1/";
const RequestBuilder = new Requests.Request.Builder("explore", "personallists");

const service = {
    fetchAllCountrySpecificStoreLists(country: string, storeId: string, isEmployee: boolean, contextStoreId?: string) {
        const url = isEmployee
            ? basePath + "lists/employeeByStore/" + RequestUtil.buildPath([country, storeId])
            : basePath + "lists/stores/" + RequestUtil.buildPath([country, storeId]);
        return Requests.get(url + "?" + RequestUtil.buildQuery({ contextStoreId: contextStoreId }), null, {
            timeout: 30000,
            headers: RequestUtil.makeCallTreeHeader()
        });
    },

    deleteListById(listId: string) {
        const template = "/lists/{listId}";
        return RequestBuilder.path(template, { listId: listId }).delete();
    }
};

export default service;
